import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import bgLogin from "../../assets/bg2_novo.png";
import "./styles.css";

import { validaCpfCnpj } from "../../services/validaCpfCnpj";
import { cpfCnpj, unMask } from "../../services/mask";
import {
  logarUsuario,
  logarUsuarioMidiaCenter,
} from "../../services/http/usuariosService";
import globals from "../../globlas";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import storageLocal from "../../services/storageLocal";
import ApiService from "../../services/apiLogin";
import services from "../../services";
import { message } from "antd";

export default function Login() {
  const history = useHistory();

  const [login, setLogin] = useState({ cpfCnpj: "", senha: "" });

  async function fnLogin(e) {
    if (e) {
      e.preventDefault();
    }
    storageLocal.set("tokenLogin", { token: "" });
    try {
      let response = await ApiService.apiLogin("AutenticarUsuario/logar", {
        email: login.cpfCnpj,
        senha: login.senha,
      });

      // Verificar se a resposta tem statusCode (erro da API)
      if (response.statusCode >= 400) {
        message.error(response.message || "Erro na autenticação");
        return;
      }

      // Verificar se a resposta tem data (sucesso)
      if (response) {
        storageLocal.set("tokenLogin", { token: response.data });
        sessionStorage.setItem("authSistema", response.data);
        services.storage.set("isAuthenticated", true);
        history.push(`/galeria-midia`);
      } else {
        message.error("Resposta inválida do servidor");
      }
    } catch (err) {
      // Verificar se o erro tem response da API
      if (err.response?.data?.message) {
        message.error(err.response.data.message);
      } else if (err.message) {
        message.error(err.message);
      } else {
        message.error("Erro ao realizar login. Tente novamente.");
      }
      console.error("Login error:", err);
    }
  }

  return (
    <div className="login-container">
      <div className="login-content">
        <h2>
          <b className="fontGellyBold">GEELY BRAND HUB</b>
        </h2>
        <hr
          style={{
            width: "40px",
            margin: "16px 0 0 0",
            border: "1.5px solid #979797",
          }}
        />
        <p style={{ fontSize: 15 }}>
          Aqui você encontra o acervo oficial da marca, um olhar visual sobre o
          nosso compromisso com inovação, design e mobilidade inteligente.
          <br />
          <br />
          Identifique-se para acessar.
        </p>

        <form onSubmit={fnLogin}>
          <div className="form-group">
            <label htmlFor="cpfCnpj" style={{ fontWeight: "bold" }}>
              E-mail
            </label>
            <input
              type="text"
              id="cpfCnpj"
              name="cpfCnpj"
              placeholder="Informe o seu e-mail"
              autoComplete="username"
              value={login.cpfCnpj}
              onChange={(e) => setLogin({ ...login, cpfCnpj: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label htmlFor="senha" style={{ fontWeight: "bold" }}>
              Senha
            </label>
            <div className="input-password">
              <input
                type="password"
                id="senha"
                name="senha"
                placeholder="Informe sua senha"
                autoComplete="current-password"
                value={login.senha}
                onChange={(e) => setLogin({ ...login, senha: e.target.value })}
              />
              <span className="icon-eye">{/* Ícone de olho aqui */}</span>
            </div>
            <div className="d-flex justify-content-end">
              {/* <Link
                to="/esqueci-minha-senha"
                style={{ color: "#979797", textDecoration: "none" }}
              >
                Esqueci minha senha
              </Link> */}
            </div>
          </div>

          <button
            type="submit"
            className="btn-login"
          >
            Entrar
          </button>
        </form>

        <div className="d-flex justify-content-between align-items-center">
          <Link
            to="/esqueci-minha-senha"
            style={{ color: "#979797", textDecoration: "none" }}
          >
            Esqueci minha senha
          </Link>
          <Link
            to="/cadastro"
            style={{ color: "#979797", textDecoration: "none" }}
          >
            Cadastre-se
          </Link>
        </div>
      </div>
    </div>
  );
}
